import { render, staticRenderFns } from "./CodificationForm.vue?vue&type=template&id=0512ccbc&"
import script from "./CodificationForm.vue?vue&type=script&lang=js&"
export * from "./CodificationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports